var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { View } from 'react-native';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet, formatAppointmentTime } from '../../utils';
import { Text } from '../Text';
import { Footer, Participants, Placeholder } from './components';
import { Focusable } from '../Focusable';
export const AppointmentCard = (_a) => {
    var { disabled, fluid, compact, onPress, style } = _a, props = __rest(_a, ["disabled", "fluid", "compact", "onPress", "style"]);
    const styles = useStyleSheet(getStyles);
    if (props.isLoading)
        return React.createElement(Placeholder, { fluid: fluid, style: style, compact: compact });
    const { subject, time, duration, status, participantStatus, participants } = props;
    return (React.createElement(Focusable, { disabled: disabled, style: [styles.container, fluid ? styles.fluid : null, style], hoverStyle: styles.hover, onPress: onPress },
        React.createElement(Text, { type: 'headline', size: 'lg', style: styles.subject, numberOfLines: 1 }, subject),
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.time, numberOfLines: 1 }, formatAppointmentTime(time, duration)),
        !compact && React.createElement(Participants, { participants: participants }),
        React.createElement(View, { style: styles.separator }),
        React.createElement(Footer, { status: status, participantStatus: participantStatus })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    hover: { backgroundColor: color.invert2.p10 },
    fluid: { flex: 1 },
    container: {
        padding: size.G,
        backgroundColor: color.invert2.p4,
        borderRadius: size.G
    },
    separator: {
        marginTop: size.G,
        marginBottom: size.G,
        backgroundColor: color.invert2.p4,
        height: 1
    },
    subject: {
        marginBottom: size.C
    },
    time: {
        color: color.invert2.p56
    }
}));
//# sourceMappingURL=index.js.map